import React, { useEffect, useState } from 'react';
import LoadingButton from '../../../LoadingButton';
import { getBankStatus} from '../../../../../helpers';
import { winnreAuth } from '../../../../../utils/axios';

const SixthStep = ({ setStep }) => {
    const [loading, setLoading] = useState(true);
    const [kycStatus, setKycStatus] = useState('');
    const [bankStatus, setBankStatus] = useState('');
    const [kycRetryCount, setKycRetryCount] = useState(0);
    const [bankRetryCount, setBankRetryCount] = useState(0);

    const getKYCStatus = () => {
        return winnreAuth({
            method: 'GET',
            url: `/winnre/user/user/kyc-status?refresh=true`
        });
    };

    const checkKYCStatus = () => {
        return getKYCStatus()
            .then((res) => {
                console.log('Returned from getKYCStatus:', res);
                setKycStatus(res?.message);
            })
            .catch((error) =>
                console.error('Error fetching KYC status:', error)
            );
    };

    const checkBankStatus = () => {
       
        return getBankStatus()
            .then((res) => {
                console.log('Returned from getBanktatus:', res);
                setBankStatus(res?.message);
            })
            .catch((error) =>
                console.error('Error fetching Bank status:', error)
            );
    };
 
    useEffect(() => {
        console.log("U1")
        if (kycStatus !== 'COMPLETED' && kycRetryCount < 4) {
            const kycIntervalId = setInterval(() => {
                checkKYCStatus();
              
                setKycRetryCount((prev) => prev + 1);
            }, 60000);

            checkKYCStatus(); // Call immediately on mount
            return () => clearInterval(kycIntervalId);
        }
    }, [kycStatus, kycRetryCount]);
    

    useEffect(() => {
        console.log("U2")
        if (
            kycStatus === 'COMPLETED' &&
            bankStatus !== 'COMPLETED' &&
            bankRetryCount < 4
        ) {
            const bankIntervalId = setInterval(() => {
                checkBankStatus();
                setBankRetryCount((prev) => prev + 1);
                // if(bankRetryCount=== 3){
                //     setBankStatus('COMPLETED');
                // }
            }, 60000);
            checkBankStatus();
            return () => clearInterval(bankIntervalId);
        }
    }, [kycStatus, bankStatus, bankRetryCount]);

    useEffect(() => {
        console.log("U3")
        if (kycStatus === 'COMPLETED' && bankStatus === 'COMPLETED') {
            setLoading(false);
            setStep(3);
        }
    }, [kycStatus, bankStatus]);

    const displayErrorMessage =
        (kycRetryCount >= 4 && kycStatus !== 'COMPLETED') ||
        (bankRetryCount >= 4 && bankStatus !== 'COMPLETED');

    console.log("kycRetry" , kycRetryCount);
    console.log("bankRetry" , bankRetryCount);

    return (
        <div className="flex flex-col justify-center items-center py-3">
            {loading && !displayErrorMessage && (
                <>
                    {' '}
                    <div className='mt-2'>
                    <LoadingButton hideButton={true} loading={true} />{' '}
                    </div>
                   
                    <h3 className=" mt-2 font-semibold text-center">
                        Fetching your documents. This might take a few minutes.
                        
                       
                    </h3>
                    <h3 className="mt-2 font-semibold text-center">
                    Thank you for your patience.
                    </h3>
                </>
            )}
            {/* {!loading && !displayErrorMessage && (
                <div className="flex flex-col items-center py-2">
                    <h3 className="mt-2 font-semibold text-center text-gray-700">
                    Taking you to the next step...
                </h3>
                <button
                    className="mt-3 bg-primary text-white px-4 py-2 rounded"
                    onClick={() => setStep(3)}
                >
                    Proceed
                </button>
                
            </div>
                
            )} */}

            {displayErrorMessage && (
                <div className=' py-3 flex flex-col justify-center items-center' >
                <h3 className=" mt-2 font-semibold text-center text-red-500">
                    We’re unable to complete the verification at this time.
                    
                </h3>
                <h3 className='mt-2 font-semibold text-center text-red-500'>
                 Please try again later.
                </h3>
                </div>
            )}
        </div>
    );
};

export default SixthStep;
